import { useState, useRef, useEffect } from 'react';

export default function StaffPicker({ staff, selected, onChange, placeholder = 'Search staff by name...' }) {
  const [search, setSearch] = useState('');
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const filtered = staff.filter(s => {
    const name = (s.display_name || s.username || '').toLowerCase();
    return name.includes(search.toLowerCase()) && !selected.find(sel => sel.discord_id === s.discord_id);
  });

  const handleAdd = (staffMember) => {
    onChange([...selected, staffMember]);
    setSearch('');
  };

  const handleRemove = (discordId) => {
    onChange(selected.filter(s => s.discord_id !== discordId));
  };

  return (
    <div ref={ref} style={{ position: 'relative' }}>
      {/* Selected tags */}
      {selected.length > 0 && (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px', marginBottom: '8px' }}>
          {selected.map(s => (
            <div key={s.discord_id} style={{
              display: 'flex', alignItems: 'center', gap: '6px',
              background: 'var(--accent-soft)', border: '1px solid var(--accent-primary)',
              borderRadius: '100px', padding: '4px 10px 4px 8px',
              fontSize: '12px', color: 'var(--accent-primary)', fontWeight: 600,
            }}>
              <div style={{
                width: '20px', height: '20px', borderRadius: '50%',
                background: 'var(--gradient-accent)',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontSize: '10px', color: '#fff', fontWeight: 700, flexShrink: 0,
              }}>
                {(s.display_name || s.username || '?')[0].toUpperCase()}
              </div>
              {s.display_name || s.username}
              <button
                onClick={() => handleRemove(s.discord_id)}
                style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'var(--accent-primary)', fontSize: '14px', padding: 0, lineHeight: 1 }}
              >×</button>
            </div>
          ))}
        </div>
      )}

      {/* Search input */}
      <input
        type="text"
        placeholder={placeholder}
        value={search}
        onChange={e => { setSearch(e.target.value); setOpen(true); }}
        onFocus={() => setOpen(true)}
        style={{
          width: '100%', padding: '10px 12px', boxSizing: 'border-box',
          border: `2px solid ${open ? 'var(--accent-primary)' : 'var(--border)'}`,
          borderRadius: '10px', fontSize: '14px', fontFamily: 'var(--font-body)',
          background: 'var(--bg-card)', color: 'var(--text-primary)', outline: 'none',
          transition: 'border-color 0.2s',
        }}
      />

      {/* Dropdown */}
      {open && (search.length > 0 || filtered.length > 0) && (
        <div style={{
          position: 'absolute', top: '100%', left: 0, right: 0,
          background: 'var(--bg-card)', border: '2px solid var(--border)',
          borderRadius: '10px', zIndex: 999, marginTop: '4px',
          boxShadow: 'var(--shadow)', maxHeight: '220px', overflowY: 'auto',
        }}>
          {filtered.length === 0 ? (
            <div style={{ padding: '14px', fontSize: '13px', color: 'var(--text-muted)', textAlign: 'center' }}>
              {search ? 'No staff found' : 'All staff already selected'}
            </div>
          ) : filtered.map(s => (
            <div
              key={s.discord_id}
              onClick={() => handleAdd(s)}
              style={{
                padding: '10px 14px', cursor: 'pointer',
                display: 'flex', alignItems: 'center', gap: '10px',
                transition: 'background 0.15s', borderBottom: '1px solid var(--border)',
              }}
              onMouseEnter={e => e.currentTarget.style.background = 'var(--bg-secondary)'}
              onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
            >
              <div style={{
                width: '30px', height: '30px', borderRadius: '50%', flexShrink: 0,
                background: 'var(--gradient-accent)',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontSize: '12px', fontWeight: 700, color: '#fff',
              }}>
                {(s.display_name || s.username || '?')[0].toUpperCase()}
              </div>
              <div>
                <div style={{ fontSize: '14px', fontWeight: 600, color: 'var(--text-primary)' }}>
                  {s.display_name || s.username}
                </div>
                <div style={{ fontSize: '11px', color: 'var(--text-muted)' }}>
                  {s.rank_name || 'No rank'} · {s.is_clocked_in ? '🟢 On shift' : '⚫ Offline'}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
